import { urls } from '@ff-os/shared-utils/urls';
import { createAsyncAppThunk } from '../createAsyncAppThunk';
import { AuthorizeResult } from './authorizeResult';

export const authorizeWithSecret = createAsyncAppThunk<string, AuthorizeResult>(
    'auth/withSecret',
    async (secret, { rejectWithValue }) => {

        const request = formatRequest(secret);
        const response = await fetch(urls.requestExistingGrant, request);

        if (response.ok) {
            return { jwt: (await response.json()).jwt, secret };
        } else {
            return rejectWithValue({ rejectType: 'http', statusCode: response.status });
        }
    }
);

const formatRequest = (secret: string) => ({
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ secret })
});